module.exports = __webpack_public_path__ + "static/media/shoulder_press_machine.5c603b96.png";